import React from "react";
import {PageFragment, PageFragmentStyleFlags} from "../../../shared/PageFragment";
import {AddOutlined} from "@mui/icons-material";
import {ListTableDataSourceFragment} from "../../../shared/ListTableDataSourceFragment";
import {TableDataContainer, TableDataRow} from "../../../shared/TableDataContainer";
import {Action, ACTION_SPACE, ActionBase, CreateActionsArgs, DisplayName} from "../../../shared/types";
import {LabelerTeamMember, LabelerTeamMembers, ResourceData} from "@/fyneai-shared/types";
import {TableDataSourceFragmentProps} from "../../../shared/TableDataSourceFragment";
import {TableData} from "../../../shared/tabledata";
import {EditTeamMemberHelper} from "./EditTeamHelper";

class LabelerTeamMemberRow implements TableDataRow {

  @TableData({name: "Name", cellSize: "xlarge"})
  name: string;

  @TableData({name: "Email", cellSize: "xlarge"})
  email: string;

  @TableData({name: "Assignments"})
  assignments: string;

  @TableData({
    name: "Actions",
    type: "actions", actions: (event, args: CreateActionsArgs) => {
      return [
        new Action("Delete", () => EditTeamMemberHelper.deleteTeamMember(args.data)).makeDestructive(),
      ];
    }
  })
  actions: any;
}

export class TeamFragment extends ListTableDataSourceFragment<LabelerTeamMember, LabelerTeamMemberRow, LabelerTeamMembers> {

  private readonly actions: ActionBase[] = [
    ACTION_SPACE,
    new Action("Invite Member",
      () => EditTeamMemberHelper.addTeamMember(),
      AddOutlined)
      .setVariant("contained"),
  ];

  constructor(props: TableDataSourceFragmentProps, context: any) {
    super(props, context, ResourceData.project().labeler.teamMembers);
  }

  protected getTitle(): string | null | undefined {
    return "Team";
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx(this.actions);
  }

  protected async fetchOnMount(): Promise<void> {
    await super.fetchOnMount();
    for (const member of this.loader.getListItems()) {
      await member.getOrLoadAssignedTasks();
    }
  }

  createTableDataRow(): LabelerTeamMemberRow {
    return new LabelerTeamMemberRow();
  }

  applyTableDataToRow(data: LabelerTeamMember, row: LabelerTeamMemberRow): void {
    row.name = DisplayName(data.firstname, data.lastname);
    row.email = data.email;
    row.assignments = data.getAssignedTasks().map(task => task.name).join(", ");
  }

  onTableCellChanged(data: LabelerTeamMember, cellId: string, value: any): void {
  }

  onTableDataSelected(data: LabelerTeamMember): void {
    EditTeamMemberHelper.editTeamMember(data);
  }

  renderContent(): React.ReactElement {
    return <TableDataContainer
      data={this.loader.getListItems()}
      source={this}/>
  }
}